import React, { useEffect, useState } from 'react';
import { Button, Stack, Text, Cluster, Icon } from '@iqueue/iq-ui';
import Modal from '../ui/Modal';
import { api } from '../../lib/api';
import { agentInfo } from '../../lib/agentRegistry';
import { useSlowWait } from '../../lib/useSlowWait';

const when = (ts) => new Date(ts).toLocaleString('ru-RU', { dateStyle: 'short', timeStyle: 'short' });

/**
 * Память агентов по комнате — то, что агенты записали себе на будущее.
 *
 * Сервер отдаёт её любому участнику намеренно, «for transparency»
 * (`GET /api/rooms/:id/memory`), но в интерфейсе она до сих пор нигде не
 * показывалась. Записи не строки списка, а короткие абзацы: заметка бывает
 * длиннее трёх строк, а `supporting` у List.Item на такое не рассчитан.
 */
export default function RoomMemoryDialog({ room, onClose }) {
  const [notes, setNotes] = useState(null);
  const [error, setError] = useState('');
  const waiting = useSlowWait(!notes && !error);

  useEffect(() => {
    let alive = true;
    api.roomMemory(room.id)
      .then(r => { if (alive) setNotes(r.notes || []); })
      .catch(e => { if (alive) setError(e.message); });
    return () => { alive = false; };
  }, [room.id]);

  return (
    <Modal
      open
      onClose={onClose}
      title={`Память агентов — ${room.name || room.id}`}
      actions={<Button variant="text" onClick={onClose}>Закрыть</Button>}
    >
      <Stack gap={300}>
        {error && <Text variant="body-small">{error}</Text>}
        {!notes && !error && (waiting ? <Text variant="body-medium" muted>Читаю память…</Text> : null)}
        {notes && notes.length === 0 && (
          <Text variant="body-medium" muted>Агенты ничего не запомнили об этой комнате.</Text>
        )}
        {(notes || []).map(n => (
          <Stack key={n.id} gap={50}>
            <Cluster gap={100} align="center" wrap={false}>
              <Icon name={agentInfo(n.agent_id).icon} size="s" />
              <Text variant="label-large" render={<span />}>@{n.agent_id}</Text>
              <Text variant="label-small" muted render={<span />}>{when(n.created_at)}</Text>
            </Cluster>
            <Text variant="body-medium">{n.note}</Text>
          </Stack>
        ))}
      </Stack>
    </Modal>
  );
}
